const METERS_PER_MILE = 1609.344;
const SQ_METERS_PER_SQ_MILE = METERS_PER_MILE * METERS_PER_MILE;
const SQ_METERS_PER_SQ_KM = 1e6;

/**
 * @param {number} meters
 */
export function formatDistanceMeters(meters) {
    const m = Number(meters);
    if (!Number.isFinite(m)) {
        return '—';
    }

    const km = m / 1000;
    const mi = m / METERS_PER_MILE;

    if (m < 1000) {
        return `${Math.round(m)} m (${mi.toFixed(2)} mi)`;
    }

    return `${km.toFixed(2)} km (${mi.toFixed(2)} mi)`;
}

/**
 * @param {number} sqMeters
 */
export function formatAreaSqM(sqMeters) {
    const area = Number(sqMeters);
    if (!Number.isFinite(area)) {
        return '—';
    }

    const km2 = area / SQ_METERS_PER_SQ_KM;
    const mi2 = area / SQ_METERS_PER_SQ_MILE;
    return `${km2.toFixed(3)} km² (${mi2.toFixed(3)} mi²)`;
}
